// 법인(bodyCorporate) ID Type — 화면 드롭다운 라벨 ↔ 저장 JSON 변환 공용 유틸.
// 저장 형태: L_GLOBAL_CONTACT / L_GLOBAL_CONTACT_PROFILE_HISTORY 의 ID_TYPE(nvarchar100) 컬럼에
//   {"TypeOfIdentificationOfShareholder":"Company Registration No."} 형태의 JSON 문자열로 저장한다.
import typeOfIdentification from '@/features/startTask/preset_task/my/components/shared/data/MBRS/type-of-identification.json';

export const ID_TYPE_JSON_KEY = 'TypeOfIdentificationOfShareholder';

export type CorporateIdTypeOption = { value: string; label: string };

/** 드롭다운 옵션 (bodyCorporate) */
export const CORPORATE_ID_TYPE_OPTIONS: CorporateIdTypeOption[] =
    ((typeOfIdentification as { bodyCorporate?: CorporateIdTypeOption[] })?.bodyCorporate ?? []).map(
        (o) => ({ value: String(o.label ?? o.value ?? ''), label: String(o.label ?? o.value ?? '') }),
    );

/** 저장값(JSON 문자열 또는 라벨) → 드롭다운 라벨 */
export function parseCorporateIdTypeLabel(raw: unknown): string {
    if (raw == null) return '';
    const s = String(raw).trim();
    if (!s) return '';
    if (s.startsWith('{')) {
        try {
            const obj = JSON.parse(s);
            const v = obj?.[ID_TYPE_JSON_KEY];
            return v == null ? '' : String(v);
        } catch {
            return '';
        }
    }
    // 하위 호환: 라벨 문자열이 그대로 들어온 경우
    return s;
}

/** 드롭다운 라벨 → 저장 JSON 문자열 (빈 값이면 빈 문자열) */
export function buildCorporateIdTypeJson(label: unknown): string {
    const s = String(label ?? '').trim();
    if (!s) return '';
    return JSON.stringify({ [ID_TYPE_JSON_KEY]: s });
}
